import { render, staticRenderFns } from "./gerenciar.vue?vue&type=template&id=31ed6819"
import script from "./gerenciar.vue?vue&type=script&lang=js"
export * from "./gerenciar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports